import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GeneralService } from 'src/app/services/general/general.service';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
  ValidatorFn,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-grupal-payment-modal',
  templateUrl: './grupal-payment-modal.component.html',
  styleUrls: ['./grupal-payment-modal.component.scss']
})
export class GrupalPaymentModalComponent implements OnInit {
  
  public datos:any;
  public payment_datos: any;
  public respuesta:any;
  public loadingQuery: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<GrupalPaymentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public general: GeneralService,
    private formBuilder: FormBuilder,
    private router: Router
  ) { 

      this.datos = data;    
    
      this.payment_datos = this.formBuilder.group({
        groupal_class_id: [null, [Validators.required]],
        payment_method: [null, [Validators.required]],
        conditions: [false, [Validators.requiredTrue]],
      });
  }

  async ngOnInit() {
    this.payment_datos.get("groupal_class_id").patchValue(this.datos.class_id);
  }

  async payGroupalClass() {

    try {
      this.loadingQuery = true;
      let response = await this.general.httpPost('groupal-class-payment', {
        groupal_class_id: this.datos.class_id,
        payment_method: this.payment_datos.controls['payment_method'].value,
      });
  
      if(response) {
        this.dialogRef.close();
        window.location.href = response.message.data;
      }

    } catch (error) {
      //console.log("error: ", error);
      this.general.showErrorForm(error);
    } finally{
      this.loadingQuery = false;
    }
  }

  get validateform() {
    return this.payment_datos.valid;
  }

  closeDialog() {
    this.dialogRef.close();
  }

	
}
